import WebsiteBehaviors from "../website-behaviors/index.js";
import LanguageBehavior from "../language-behavior.js";
import Selection from "../selection.js";
import {injectStyles} from "../utils/document.js";

class RedShelf extends WebsiteBehaviors {
	identifier() {
		return "RedShelf";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return (location.host === "platform.virdocs.com");
	}

	styles() {
		// language=CSS
		return `
			body {
				display: contents;
			}
			html {
				margin: 0 2em !important;
			}
			.annotation-details {
				display: none !important;
			}
		`;
	}

	async topFrameHandler() {
		// language=CSS
		const styles = `
			.manifest-iframe.no-cpl {
				padding: 0 !important;
			}
		`;

		injectStyles(window.document, styles);

		return null;
	}

	shouldFrameTakeControl() {
		return true;
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'annotation' implicitly has an 'any' typ... Remove this comment to see the full error message
	alterNewHighlight(annotation) {
		const {range, text} = (document.body as any).PnSelectionData;
		annotation.selection = Selection.GetSelectionFromRange(range);
		annotation.selectedText = text;
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
	async mouseUp(event, bypassHighlightRules, isSelectionEqual, isPageCoordEqual, page, processOrgProxy) {
		const lang = document.documentElement.lang;
		const languageRules = LanguageBehavior.getLanguageRules(lang);

		const validSelection = Selection.ProcessAndValidateSelection(languageRules, bypassHighlightRules);

		if (validSelection && !(isSelectionEqual && isPageCoordEqual)) {
			const text = Selection.GetSelectedText();
			const selection = document.getSelection();
			// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
			const range = selection.getRangeAt(0);

			(document.body as any).PnSelectionData = {range, text};

			Selection.ClearTextSelection(); // prevents RedShelf annotation functionality

			return true;
		} else
			return false;
	}

	getCopyButtonLabel() {
		return "Copy With Citation";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'selectedText' implicitly has an 'any' t... Remove this comment to see the full error message
	async copySelectionToClipboard(selectedText, document, loadCitation) {
		const {text} = document.body.PnSelectionData;
		selectedText = text.trim();

		super.copySelectionToClipboard(selectedText, document, null);
	}
}

export default RedShelf;
